var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingLeaveChipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 12.1332C3.93825 12.1332 1.44818 9.7261 1.44818 6.7665C1.44818 4.0449 3.55639 1.79557 6.27577 1.4507V0.507568C3.01763 0.856168 0.482666 3.5241 0.482666 6.7665C0.482666 10.246 3.40046 13.0665 6.99991 13.0665C10.3546 13.0665 13.1145 10.616 13.4747 7.4665H12.499C12.1423 10.0952 9.81536 12.1332 6.99991 12.1332Z",
    fill: "#3F2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 6.53325H7.67974C7.60733 6.33539 7.44609 6.17952 7.2414 6.10952V2.33325H6.75864V6.10952C6.47815 6.20612 6.27588 6.46232 6.27588 6.76659C6.27588 7.15299 6.60029 7.46659 7.00002 7.46659C7.31478 7.46659 7.57981 7.27105 7.67974 6.99992H11.5862V6.53325Z",
    fill: "#3F2E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56181 2.01072L10.0465 1.19919C9.68925 1.01579 9.31222 0.862251 8.91877 0.745117L8.66821 1.64906C8.97959 1.74332 9.27698 1.86652 9.56181 2.01072Z",
    fill: "#3F2E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5396 6.53319H13.5051C13.4902 6.13232 13.4385 5.74126 13.3497 5.36279L12.417 5.60453C12.4855 5.90506 12.5251 6.21586 12.5396 6.53319Z",
    fill: "#3F2E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7451 2.81619L11.4297 2.15446C11.1313 1.8866 10.8084 1.64626 10.4622 1.43579L9.97852 2.245C10.2518 2.41393 10.5071 2.60573 10.7451 2.81619Z",
    fill: "#3F2E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6768 3.88671L12.5144 3.41957C12.2967 3.08497 12.0476 2.77231 11.771 2.48438L11.0864 3.14611C11.3041 3.37571 11.5021 3.62304 11.6768 3.88671Z",
    fill: "#3F2E00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20142 1.53014L8.45149 0.628534C8.05997 0.542201 7.6559 0.492738 7.24121 0.478271V1.4116C7.56949 1.4256 7.89052 1.46387 8.20142 1.53014Z",
    fill: "#3F2E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2943 5.15338L13.2294 4.91165C13.1082 4.53131 12.9494 4.16684 12.7592 3.82104L11.9202 4.28958C12.0689 4.56491 12.1963 4.85285 12.2943 5.15338Z",
    fill: "#3F2E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingLeaveChipIcon);
export default __webpack_public_path__ + "static/media/pending-leave-chip-icon.a18e41bd101c688d898e71c561086abb.svg";
export { ForwardRef as ReactComponent };